import React from 'react';

import * as TextC from './_ccbTextC';
import * as BtnC from './_cccBtnC';
import * as GridC from './_cccGridC';
import { a } from './_cmABT';
import * as _cr from './_cr';
import * as _ht from './_ht';

//import * as icv from './icv';

export const N = (pz: {
  abtz?: {
    btnIconz?: _ht.dz,
    textTtlz?: _ht.dz,
  },
  cz: {
    ttl?: _ht.s,
    goHome: () => void, // go home
    lot: () => void, // logout
  },
  boxStlz?: _ht.dz,
  children: React.FC
}) => {

  return (
    _cr.c(GridC.N, {
      boxStlz: a(`dw/f dh/f`),
      lineCs: [
        {
          boxStlz: a(`dh/pageHdr dw/f fd/rbc sc/lt1`),
          cellCs: [
            {
              boxClds: [

                _cr.c(BtnC.N, {
                  abtz: {
                    ... pz.abtz?.btnIconz,
                    icn: 'navicon',
                  },
                  lblCz: {
                    text: `メニュー`,
                  },
                  frmCz: {
                    pslPtyz: {
                      onPrs: pz.cz.goHome,
                    }            
                  },
                }),

              ]
            },
            {
              boxStlz: a(`f/1`),
              boxClds: [
                pz.cz.ttl ?
                _cr.c(TextC.N, {
                  abtz: pz.abtz?.textTtlz,
                  text: pz.cz.ttl,
                })
                : undefined,
              ]
            },
            {
              boxClds: [

                _cr.c(BtnC.N, {
                  abtz: {
                    ... pz.abtz?.btnIconz,
                    icn: 'sign-out',
                  },
                  lblCz: {
                    text: `ログアウト`,
                  },
                  frmCz: {
                    pslPtyz: {
                      onPrs: pz.cz.lot
                    }            
                  },
                }),

              ]
            }

          ]
        },
        {
          boxStlz: a(`dh/main dw/f`),
          cellCs: [
            {
              boxStlz: {
                ... a(`dw/f dh/f fd/rss`),
                ... pz.boxStlz,
              },
              boxClds: pz.children
            }
          ]
        },
      ]
    })

  )
};
